import React from 'react';
import Cmi5 from '@xapi/cmi5';

let cmi5;
if (Cmi5.isCmiAvailable) cmi5 = new Cmi5();

export const Cmi5Context = React.createContext(cmi5);
